export const Modals = {
  dom: null,
  init() {
    this.dom = {
      body: document.querySelector('.js-meal-modal-body'),
      form: document.querySelector('#change-daily-recipes'),
      warningModal: document.querySelector('#warning-modal'),
      agreeWarningButton: document.querySelector('#agree-warning'),
      disagreeWarningButton: document.querySelector('#disagree-warning'),
      submitWarning: document.querySelector('.js-open-warning-modal'),
    };
    this.dom.submitWarning?.addEventListener('click', this.showModal.bind(this));
    this.dom.agreeWarningButton?.addEventListener('click', this.continueWithWarning.bind(this));
    this.dom.disagreeWarningButton?.addEventListener('click', this.hideModal.bind(this));
  },
  continueWithWarning(e) {
    const href = e.currentTarget.dataset.href;
    this.hideModal();

    this.dom.form && this.dom.form.submit();
    if (href) window.location = href;
  },
  showModal(e) {
    e.preventDefault();
    this.dom.warningModal.classList.remove('hidden');
    this.dom.body.classList.add('overflow-hidden');
  },
  hideModal() {
    this.dom.warningModal.classList.add('hidden');
    this.dom.body.classList.remove('overflow-hidden');
  },
};

document.addEventListener('DOMContentLoaded', () => {
  Modals.init();
});
